module.exports = __webpack_public_path__ + "img/Gansu-speed.8f0b8081.png";